<template>
    <select
        class="base-select"
        :value="modelValue"
        :disabled="disabled"
        :name="name"
        @input="update($event.target.value)"
    >
        <option
            v-if="showEmpty"
            value=""
        >
            Please select
        </option>

        <option
            v-for="(option, index) in options"
            :key="index"
            :value="option.value"
            :disabled="typeof option.disabled === 'undefined' ? false : option.disabled"
            :class="option.class || []"
        >
            {{ option.label }}
        </option>
    </select>
</template>

<script>
export default {
    props: {
        modelValue: null,
        name: String,
        disabled: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            required: true,
        },
        showEmpty: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    // TODO: Remove when appropriate
    // Needed to suppress a warning currently emitted due to current vue bug
    emits: ['update:modelValue'],

    methods: {
        update(value) {
            if (value === '') {
                value = null;
            }

            this.$emit('update:modelValue', value);
        }
    },
}
</script>

<style>
.base-select {
    @apply block w-full outline-none text-midnight border border-swiss-coffee p-3.5 cursor-pointer bg-white;
}
</style>
